<template>
	<div class="mb-40">
		<Header :title="getWelcomeString" icon="Home" />

		<LoadingPlaceholder  :loading="!insightsAndTopline &&  !userDonutData && !chartData " :stats="true" :charts="true" :table="false" />

		<div v-if="insightsAndTopline && userDonutData && chartData">

			<SubHeader class="mt-5" v-if="insightsAndTopline != undefined" title="Lifetime value">

				<template v-slot:stats>
					<StatBox name="Transactions processed" :number="insightsAndTopline.totalTransactionsProcessed.toLocaleString()"
						currency="" icon="Calendar" />
					<StatBox name="Total Transaction volume"
						:number="Math.abs(insightsAndTopline.totalTransactionVolume.toFixed(2)).toLocaleString()"
						currency="£" icon="BadgePoundSterling" />
					<StatBox name="Total Cashback" :number="insightsAndTopline.totalCashback.toFixed(2).toLocaleString()" currency="£"
						icon="BadgePoundSterling" />
					<StatBox name="Total Commission" :number="insightsAndTopline.totalCommission.toFixed(2).toLocaleString()"
						currency="£" icon="BadgePoundSterling" />
				</template>
			</SubHeader>

			<WhiteBox title="Insights">
				<template v-slot:content>

					<div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
						<div class="border border-gray-200 p-3 rounded-lg">
							<div class="flex justify-start mb-2">
								<h2 class="text-md font-medium">User breakdown</h2>
							</div>
							<div>
								<Doughnut v-if="userDonutData != undefined" :data="userDonutData"
									:options="chartOptions" :plugins="[centerTextPlugin]" />
							</div>
						</div>
						<div class="border border-gray-200 p-3 rounded-lg">
							<div class="flex justify-start mb-2">
								<h2 class="text-md font-medium">Program breakdown</h2>
							</div>
							<div>
								<Doughnut v-if="chartData != undefined" :data="chartData" :options="chartOptions"
									:plugins="[centerTextPluginOffers]" />
							</div>
						</div>
						<div class="border border-gray-200 p-3 rounded-lg">
							<div class="flex justify-start mb-2">
								<h2 class="text-md font-medium">Offer management</h2>
							</div>
							<div v-if="insightsAndTopline != undefined">
								<StatBox name="Total approved offers" :number="insightsAndTopline.totalAvailableOffers != null ? insightsAndTopline.totalAvailableOffers: 0 "
									currency="" icon="Calendar" />
								<StatBox name="Pending approvals" :number="insightsAndTopline.pendingApprovals != null ? insightsAndTopline.pendingApprovals : 0"
									currency="" icon="Calendar" />
								<StatBox name="Declined offers" :number="insightsAndTopline.declinedOffers != null ? insightsAndTopline.declinedOffers : 0" currency=""
									icon="BadgePoundSterling" />


							</div>
						</div>
						<div class=" p-3 rounded-lg border border-gray-200">
							<div v-if="currentInvoiceData != undefined" class="flex justify-start mb-2">
								<h2 class="text-md font-medium">Cashback settlements for {{
									niceDateTime(currentInvoiceData.startDate) }} </h2>
							</div>
							<div v-if="currentInvoiceData != undefined">
								<StatBox name="Pending balance" :number="currentInvoiceData.amount != null ? currentInvoiceData.amount.toFixed(2): 0.00"
									currency="£" icon="Calendar" />
								<StatBox name="End user cashback" :number="currentInvoiceData.endUserAmount != null ? currentInvoiceData.endUserAmount.toFixed(2): 0.00"
									currency="£" icon="BadgePoundSterling" />
								<StatBox name="Commission" :number="currentInvoiceData.commissionAmount != null ? currentInvoiceData.commissionAmount.toFixed(2): 0.00"
									currency="£" icon="BadgePoundSterling" />

							</div>
							<div v-else class="flex justify-start mb-2">
								<h2 class="text-md font-medium">Cashback settlements do not exist in sandbox mode</h2>
							</div>
						</div>
					</div>
				</template>
			</WhiteBox>


			<WhiteBox class="hidden" title="Reporting summary" subText="Date to Date">
				<template v-slot:buttons>
					<CustomButton id="createContract" small text="Edit timeframe" type="action" icon="CalendarDays"
						@click="showFormModal = true" />
				</template>
				<template v-slot:content>
					<div class="my-2">
						<div class="grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-2">
							<div class="bg-gray-100 h-[400px] p-2 pb-2">
								<div class="flex justify-start mb-2">
									<h2 class="text-md font-medium">Active users (AUs)</h2>
								</div>
								<StatBox name="Total active users" :number="66" currency="" icon="Calendar" />
								<div class="mt-5 h-[250px]">
									<Line class="" :data="lineData" :options="lineOptions" />
								</div>
							</div>
							<div class="bg-gray-100 h-[400px] p-2 pb-2">
								<div class="flex justify-start mb-2">
									<h2 class="text-md font-medium">Transaction volume</h2>
								</div>
								<StatBox name="Transaction volume" :number="66" currency="" icon="Calendar" />
								<div class="mt-5 h-[250px]">
									<Line class="" :data="lineData" :options="lineOptions" />
								</div>
							</div>
							<div class="bg-gray-100 h-[400px] p-2 pb-2">
								<div class="flex justify-start mb-2">
									<h2 class="text-md font-medium">Cashback</h2>
								</div>
								<StatBox name="Cashback" :number="66" currency="" icon="Calendar" />
								<div class="mt-5 h-[250px]">
									<Line class="" :data="lineData" :options="lineOptions" />
								</div>
							</div>
							<div class="bg-gray-100 h-[400px] p-2 pb-2">
								<div class="flex justify-start mb-2">
									<h2 class="text-md font-medium">Comission</h2>
								</div>
								<StatBox name="Comission" :number="66" currency="" icon="Calendar" />
								<div class="mt-5 h-[250px]">
									<Line class="" :data="lineData" :options="lineOptions" />
								</div>
							</div>
						</div>
					</div>



				</template>

			</WhiteBox>
		</div>
	</div>
</template>

<script>
import SubHeader from '@/components/SubHeader.vue';
import StatBox from "@/components/StatBox.vue";
import { DateTime } from 'luxon';
import WhiteBox from "@/components/WhiteBox.vue";
import { Doughnut, Line } from 'vue-chartjs'
import {
	Chart as ChartJS, ArcElement, Tooltip, Legend, LinearScale, CategoryScale,
	PointElement,
	LineElement,
	Title
} from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend, LinearScale, PointElement, LineElement, Title, CategoryScale)
import CustomButton from "@/components/inputs/CustomButton.vue";
import Header from "@/components/Header.vue";
import LoadingPlaceholder from "@/components/LoadingPlaceholder.vue";


export default {
	name: 'LaunchPad',
	components: {
		LoadingPlaceholder,
		SubHeader,
		Header,
		StatBox,
		CustomButton,
		WhiteBox,
		Doughnut,
		Line
	},
	data() {
		return {
			publisher: localStorage.getItem('publisher'),
			currentInvoiceData: undefined,
			name: localStorage.getItem('firstName'),
			insightsAndTopline: undefined,

			userDonutData: undefined,
			startDate: '',
			endDate: '',
			formStart: '',
			formEnd: '',
			currentHour: new Date().getHours(),
			chartData: undefined,
			centerText: "",
			centerTextOffers: "",


			chartOptions: {
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: {
						position: 'bottom'
					},
					tooltip: {
						callbacks: {
							label: function (context) {
								const value = context.raw; // Get the value
								return `${context.label}: ${value}`; // Add the % sign
							},
						},
					},
					title: {
						display: false,
						text: 'Transaction count'
					}
				}
			},


			lineData: {
				labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
				datasets: [
					{
						label: 'Data One',
						backgroundColor: '#f87979',
						data: [40, 39, 10, 40, 39, 80, 40]
					}
				]
			},

			lineOptions: {
				responsive: true,
				maintainAspectRatio: false
			}


		}
	},
	mounted() {
		document.title = "Dashboard | Home";
	},
	computed: {
		centerTextPlugin() {
			return {
				id: "centerText",
				beforeDraw: (chart) => {
					const { ctx } = chart;
					const centerX = chart.getDatasetMeta(0).data[0].x;
					const centerY = chart.getDatasetMeta(0).data[0].y;

					ctx.save();
					ctx.font = `bold ${18}px Arial`;
					ctx.fillStyle = "black";
					ctx.textAlign = "center";
					ctx.textBaseline = "middle";
					ctx.fillText(this.getCenterText(), centerX, centerY);
					ctx.restore();
				},
			}
		},

		centerTextPluginOffers() {
			return {
				id: "centerText",
				beforeDraw: (chart) => {
					const { ctx } = chart;
					const centerX = chart.getDatasetMeta(0).data[0].x;
					const centerY = chart.getDatasetMeta(0).data[0].y;

					ctx.save();
					ctx.font = `bold ${18}px Arial`;
					ctx.fillStyle = "black";
					ctx.textAlign = "center";
					ctx.textBaseline = "middle";
					ctx.fillText(this.getCenterTextOffers(), centerX, centerY);
					ctx.restore();
				},
			}
		},

		getWelcomeString() {

			console.log(this.currentHour)

			if (this.currentHour < 12) return `Good morning, ${this.name}! ☀️`;
			if (this.currentHour < 18) return `Good afternoon, ${this.name}! 🌤️`;
			return `Good evening, ${this.name}! 🌙`;
		}
	},
	created() {
		this.getCurrentPayout()
		const now = DateTime.local();
		const startOfMonth = now.startOf('month');
		const endOfMonth = now.endOf('month');

		this.startDate = startOfMonth.minus({ month: 2 });
		this.endDate = endOfMonth;
		this.formStart = this.startDate.toFormat('dd-MM-yyyy')
		this.formEnd = this.endDate.toFormat('dd-MM-yyyy')

		this.getToplineAndInsightData()
	},


	methods: {

		getCenterText() {
			return this.centerText; // Retrieves text from data
		},

		getCenterTextOffers() {
			return this.centerTextOffers; // Retrieves text from data
		},

		async getToplineAndInsightData() {

			try {
				const token = localStorage.getItem('token')
				const api = localStorage.getItem('apiType')

				this.loadingCategories = true

				const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/analytics/homepage`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()
					this.centerText = object.totalUsers + ' users'
					this.centerTextOffers = object.totalActiveOffers + ' offers'
					this.insightsAndTopline = object


					this.userDonutData = {
						labels: ["Active users", "Inactive users"],
						datasets: [{
							data: [object.activeUsers, object.inactiveUsers]
						}]
					}

					this.chartData = {
						labels: ["Payment linked offers", "Click to activate offers", "Affiliate offers"],
						datasets: [
							{
								backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
								data: [object.paymentLinkedOffers, object.clickToActiveOffers, object.affiliateOffers]
							}]
					}

				}

			} catch (error) {
				console.error(error)
				return;
			}
		},

		niceDateTime(dateObject) {
			return DateTime.fromMillis(dateObject).toFormat('MMMM yyyy')
		},

		async getCurrentPayout() {
			try {
				const token = localStorage.getItem('token')
				const api = localStorage.getItem('apiType')

				this.loading = true

				const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/payout/current`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()
					this.currentInvoiceData = object
				}

			} catch (error) {
				return;
			}

		},

	}

}
</script>

<style></style>